import { IGeoLocation } from '~domain/entities/UserLocation';

export class SearchedLocationRepository {
    public geolocation: IGeoLocation;

    public updateGeolocation = (geolocation: IGeoLocation) => {
        this.geolocation = geolocation;
    };
}
